import type { QueryKey } from "@tanstack/react-query"

enum EQueryKeyBase {
    SessionIndividual = "CoachGroupIndividual",
    SessionSummary = "CoachGroupSummary",
    Session = "CoachGroupSessionSummaryConfig"
}

const EQueryKey: {
    SessionIndividual(params: { sessionId: number; individualId: number }): QueryKey
    SessionSummary(params: { sessionId: number }): QueryKey
    SessionSummaryConfig(params: { sessionId: number }): QueryKey
} = {
    SessionIndividual: (params: { sessionId: number; individualId: number }): QueryKey => [
        EQueryKeyBase.SessionIndividual,
        `sessionId:${params.sessionId}`,
        `individualId:${params.individualId}`
    ],
    SessionSummary: (params: { sessionId: number }): QueryKey => [
        EQueryKeyBase.SessionSummary,
        `sessionId:${params.sessionId}`
    ],
    SessionSummaryConfig: (params: { sessionId: number }): QueryKey => [
        EQueryKeyBase.Session,
        `sessionId:${params.sessionId}`
    ]
}

const EQueryUrl: {
    SessionIndividual(params: { sessionId: number; individualId: number }): string
    SessionSummary(params: { sessionId: number }): string
    SessionSummaryConfig(params: { sessionId: number }): string
} = {
    SessionIndividual: (params: { sessionId: number; individualId: number }): string =>
        `/api/coach-portal/session/${params.sessionId}/participant-progress/${params.individualId}/`,
    SessionSummary: (params: { sessionId: number }): string =>
        `/api/coach-portal/session/${params.sessionId}/pre-session-summary/`,
    SessionSummaryConfig: (params: { sessionId: number }): string => `/api/coach-portal/session/${params.sessionId}/`
} as const

export {
    EQueryKeyBase as ECoachGroupQueryKeyBase,
    EQueryKey as ECoachGroupQueryKey,
    EQueryUrl as ECoachGroupSessionQueryUrl
}
